export enum POLICY_STATUS {
    HELP_BEFORE_CHECK="Help before check",
    STILL_TO_BE_CHECKED= "Still to be checked" , 
    OK=  "OK" ,
    NOT_OK= "Not OK",
    NOT_APPLICABLE ="Not Applicable"
}


export enum POLICY_CHECK_STATUS {
    OK =  "OK" 
}